<ng-container *ngIf="viewType=='MIN'">
  <div class="hpanel-btf margin-bottom-5-btf gs-widget-card">
    <app-common-skeleton *ngIf="loadAPIcall" [countforView]="1" [NameOftheScreen]="'widgets'"></app-common-skeleton>

    <ng-container *ngIf="!loadAPIcall">
      <div class="panel-heading-btf hbuilt-btf widget-header-btf gs-widget-header">
        <span class="header-title-btf">{{ headerTitle }}</span>
        <span class="refresh-icon-btf" title="Refresh" (click)="getSuggestions()">
          <ng-icon name="tablerRefresh"></ng-icon>
        </span>
      </div>

      <div class="panel-body-btf padding-top-6-btf widget-content-btf gs-widget-body">
        <div class="row-btf">
          <ul class="profile-list-btf">
            <ng-container *ngFor="let item of bussinesssuggestionList | slice: 0:3; let i = index">
              <app-common-profile-info [type]="'BUSINESS'" [userIdInput]="item.businessId"
                [page]="'BUSINESS'" [data]="item" (click)="route(item)" class="business-item-btf">
                <ng-container headline1>
                  <span class="business-name-btf">{{item.businessName}}</span>
                </ng-container>
                <p headline2 class="business-followers-btf">{{item.followerCnt}} Follower(s)</p>
                <ng-container btn>
                  <button class="follow-btn-btf" (click)="follow(item.businessId); $event.stopPropagation()">
                    Follow
                  </button>
                </ng-container>
              </app-common-profile-info>
            </ng-container>

            <button class="gs-743-more-btn" type="button"
                    *ngIf="totalCount > 0"
                    (click)="openModal(template)">
              View more →
            </button>

            <div class="gs-empty" *ngIf="!bussinesssuggestionList || bussinesssuggestionList?.length == 0">
              <span class="gs-empty-icon"><ng-icon name="tablerSparkles"></ng-icon></span>
              <div class="gs-empty-title">No suggestions yet</div>
              <div class="gs-empty-sub">We'll suggest businesses as we learn what you like.</div>
            </div>
          </ul>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>


<ng-template #template>
  <div class="modal-container-btf">
    <div class="modal-header-btf">
      <label class="modal-title-btf">Businesses To Follow</label>
      <button type="button" class="close-btn-btf" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-search-btf">
      <input type="text" class="form-control" (keyup)="onSearch($event)" name="searchName"
        placeholder="Search business" [(ngModel)]="searchName" />
    </div>

    <div class="select-all-container-btf" *ngIf="bussinesssuggestion?.length > 1 && !beingTyped">
      <label class="select-all-label-btf">Select All</label>
      <div class="custom-checkbox-btf">
        <label class="checkbox-label-btf">
          <input type="checkbox" [(ngModel)]="theChecker" (change)="checkAll($event)" />
          <span class="checkmark-btf"></span>
        </label>
      </div>
    </div>

    <div class="modal-content-btf">
      <div class="business-list-item-btf" *ngFor="let item of bussinesssuggestion | filter: searchName | paginate: { itemsPerPage: 5, currentPage: page, totalItems: totalCount }">
        <div class="business-row-btf">
          <div class="business-logo-btf">
            <img [src]="imgUrl + item['businessLogo']" onerror="this.src='assets/images/gallery/company.png'" alt="Business Logo" />
          </div>
          <div class="business-info-btf" (click)="route(item)">
            <label class="business-name-link-btf" title="{{ item.businessName }}">
              {{ item.businessName }}
            </label>
            <div class="business-follower-count-btf" title="{{item.followerCnt}} Follower(s)">
              {{item.followerCnt}} Follower(s)
            </div>
          </div>
          <div class="business-checkbox-btf">
            <div class="custom-checkbox-btf">
              <label class="checkbox-label-btf">
                <input type="checkbox" value="{{ item.businessId }}" [(ngModel)]="item.checked"
                  (change)="onCheckboxChange(item, $event)" />
                <span class="checkmark-btf"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer-btf">
      <div class="pagination-container-btf">
        <pagination-controls class="pagination-btf" (click)="movePage(page)" (pageChange)="page = $event">
        </pagination-controls>
      </div>
      <div class="footer-buttons-btf">
        <button class="btn-close-btf" (click)="closeModal()">
          Close
        </button>
        <button class="btn-follow-btf" [disabled]="selectedEntities.length == 0" (click)="followAll()">
          Follow {{selectedEntities.length}}
        </button>
      </div>
    </div>
  </div>
</ng-template>
